import { render, staticRenderFns } from "./ReplaceDishModal.vue?vue&type=template&id=19a1b5ea&scoped=true"
import script from "./ReplaceDishModal.vue?vue&type=script&lang=js"
export * from "./ReplaceDishModal.vue?vue&type=script&lang=js"
import style0 from "./ReplaceDishModal.vue?vue&type=style&index=0&id=19a1b5ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19a1b5ea",
  null
  
)

export default component.exports